import { Capacitor, registerPlugin } from '@capacitor/core';

const RecordingGuardPlugin = registerPlugin('RecordingGuard');

export function normalizeRenderProcessMarker(marker = {}) {
  const reason = marker.reason === 'renderer-crash'
    ? 'renderer-crash'
    : marker.reason === 'renderer-killed'
      ? 'renderer-killed'
      : null;
  const crashCount = Math.max(0, Number(marker.crashCount) || 0);
  return {
    pending: !!reason,
    reason,
    occurredAt: Number.isFinite(Number(marker.occurredAt)) ? Number(marker.occurredAt) : null,
    crashCount,
    loopGuarded: crashCount >= 3,
    activeRecordingId: typeof marker.activeRecordingId === 'string' ? marker.activeRecordingId : null
  };
}

export async function inspectRenderProcessRecovery({
  isNative = Capacitor.isNativePlatform(),
  plugin = RecordingGuardPlugin
} = {}) {
  if (!isNative) return { supported: false, pending: false, reason: null };
  try {
    return { supported: true, ...normalizeRenderProcessMarker(await plugin.getRenderRecoveryMarker()) };
  } catch (error) {
    return { supported: true, pending: false, reason: null, error: error?.message || String(error) };
  }
}

export async function clearRenderProcessRecovery({
  isNative = Capacitor.isNativePlatform(),
  plugin = RecordingGuardPlugin
} = {}) {
  if (!isNative) return { supported: false, cleared: false };
  try {
    await plugin.clearRenderRecoveryMarker();
    return { supported: true, cleared: true };
  } catch (error) {
    return { supported: true, cleared: false, error: error?.message || String(error) };
  }
}
